import React, { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db, appId } from '../firebase/config';

const MaintenanceGuard = ({ children }) => {
    const [maintenanceActive, setMaintenanceActive] = useState(false);
    const [isUnlocked, setIsUnlocked] = useState(sessionStorage.getItem('dev_unlocked') === 'true');
    const [passInput, setPassInput] = useState('');
    const [loading, setLoading] = useState(true);

    const DEV_PASSWORD = "@!?7739Az."; // A tua password de acesso

    useEffect(() => {
        // Escuta o campo 'emManutencao' que o teu SettingsView.js altera
        const docRef = doc(db, `artifacts/${appId}/public/data/configuracoes`, 'sistema');
        const unsub = onSnapshot(docRef, (docSnap) => {
            if (docSnap.exists()) {
                setMaintenanceActive(docSnap.data().emManutencao || false);
            }
            setLoading(false);
        });
        return () => unsub();
    }, []);

    const handleUnlock = (e) => {
        e.preventDefault();
        if (passInput === DEV_PASSWORD) {
            sessionStorage.setItem('dev_unlocked', 'true');
            setIsUnlocked(true);
        } else {
            alert("Código incorreto.");
        }
    };

    if (loading) return null; // Ou um spinner de loading

    // Se a manutenção estiver DESATIVADA no Admin, ou se já meteste a password, mostra o site
    if (!maintenanceActive || isUnlocked) {
        return children;
    }

    // Caso contrário, mostra a tela de bloqueio
    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-6 text-center">
            <div className="bg-white p-8 rounded-2xl shadow-xl max-w-md w-full">
                <i className="fas fa-tools text-indigo-500 text-5xl mb-4"></i>
                <h1 className="text-2xl font-bold text-gray-800">Vintage Praia</h1>
                <p className="text-gray-500 mt-2 mb-6 text-sm">
                    O nosso site está em manutenção para melhorar a sua experiência. 
                    Pedimos desculpa pelo incómodo.
                </p>
                
                <form onSubmit={handleUnlock} className="flex flex-col gap-3">
                    <input 
                        type="password" 
                        placeholder="Acesso privado (Staff)"
                        className="p-3 border rounded-xl text-center outline-none focus:ring-2 focus:ring-indigo-500"
                        value={passInput}
                        onChange={(e) => setPassInput(e.target.value)}
                    />
                    <button type="submit" className="bg-indigo-600 text-white p-3 rounded-xl font-bold hover:bg-indigo-700 transition-colors">
                        Entrar com código
                    </button>
                </form>
            </div>
        </div>
    );
};

export default MaintenanceGuard;